import React, { useMemo } from 'react';
import { Grid } from '@mui/material';
import { KpiCard } from 'dashboard/components/common';

/** Total / active / blocked / opted-in tiles for the audience page. */
export default function AudienceKpiRow({ rows }) {
  const stats = useMemo(() => ({
    total:    rows.length,
    active:   rows.filter((r) => r.status === 'active').length,
    blocked:  rows.filter((r) => r.status === 'blocked').length,
    opted_in: rows.filter((r) => r.marketing_email_opt_in).length,
  }), [rows]);

  return (
    <Grid container spacing='12px'>
      <Grid item xs={6} md={3}><KpiCard label='All customers' value={stats.total}    /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Active'        value={stats.active}   accent='#16a34a' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Blocked'       value={stats.blocked}  accent='#dc2626' /></Grid>
      <Grid item xs={6} md={3}><KpiCard label='Email opt-ins' value={stats.opted_in} accent='#2563eb' /></Grid>
    </Grid>
  );
}
